import { useRouteLoaderData } from "@remix-run/react";
import { loader as rootLoader } from "~/root";
import { WrapperComponents } from "../wrappers/WrapperComponents";
import { LoaderDataPage } from "~/data/loaders/page";
import { type TemplateGetInvolved } from "~/sanity/types-mapped";
import { HeroPrimary } from "../headers/HeroPrimary";
import { SectionBlockPinnedMediaItems } from "../sections/blocks/SectionBlockPinnedMediaItems";
import { SectionBlockMediaFeatured } from "../sections/blocks/SectionBlockMediaFeatured";
import {
  SectionBlockMediaItem,
  type SectionBlockMediaItemProps,
} from "../sections/blocks/SectionBlockMediaItem";
import { SectionGridColumns } from "../sections/grids/SectionGridColumns";
import { CardIconContent } from "../components/cards/CardIconContent";
import { CardCarousel } from "../components/cards/CardCarousel";
import { SectionCardCarousel } from "../sections/blocks/SectionCardCarousel";

export interface ITemplateGetInvolved {
  data: Pick<LoaderDataPage, "industry"> & TemplateGetInvolved;
}

export default function TemplateGetInvolved({ data }: ITemplateGetInvolved) {
  const rootData = useRouteLoaderData<typeof rootLoader>("root");
  const socials = rootData?.settings?.data?.socials;

  const {
    heroPrimary,
    sectionBlockPinnedMediaItems,
    featuredImage,
    callToActionDonation,
    callToAction,
    sectionGridThreeCards,
    sectionBlockCardCarousel,
  } = data;

  // console.log("templateGetInvolved", data);

  return (
    <>
      {heroPrimary && <HeroPrimary data={heroPrimary} />}
      <WrapperComponents>

        {callToActionDonation && (
          <SectionBlockMediaItem data={callToActionDonation} />
        )}
        {sectionBlockPinnedMediaItems && (
          <SectionBlockPinnedMediaItems data={sectionBlockPinnedMediaItems} />
        )}

        {sectionBlockCardCarousel &&
          sectionBlockCardCarousel.items.length > 0 && (
            <SectionCardCarousel
              theme="colour"
              data={{
                text: sectionBlockCardCarousel.text,
                title: sectionBlockCardCarousel.title,
                link: sectionBlockCardCarousel.link,
              }}
            >
              {Array.isArray(sectionBlockCardCarousel.items) &&
                sectionBlockCardCarousel.items.map(
                  (item: any, index: number) => (
                    <CardCarousel
                      heightFull
                      theme="light"
                      card={{
                        title: item.title,
                        text: item.text,
                      }}
                      key={index}
                      index={index + 1}
                    />
                  ),
                )}
            </SectionCardCarousel>
          )}

        {sectionGridThreeCards && sectionGridThreeCards.cards && (
          <SectionGridColumns
            title={sectionGridThreeCards.title}
            subtitle={sectionGridThreeCards.subtitle}
          >
            {sectionGridThreeCards.cards &&
              sectionGridThreeCards.cards.map((card, index) => {
                return <CardIconContent key={index} card={card} />;
              })}
          </SectionGridColumns>
        )}
        {featuredImage && (
          <SectionBlockMediaFeatured data={{ image: featuredImage }} />
        )}
        {callToAction && (
          <SectionBlockMediaItem
            data={(() => {
              const cta = callToAction as object & { showSocials?: boolean };
              return {
                ...cta,
                ...(cta.showSocials && socials ? { socials } : {}),
              } as SectionBlockMediaItemProps["data"];
            })()}
            inverse
          />
        )}
      </WrapperComponents>
    </>
  );
}
